import React from 'react';
import { Circles } from "react-loader-spinner";

function Spinner() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        zIndex: 9999,
      }}
    >
      <Circles
        height="60"
        width="60"
        color="#1814f3"
        ariaLabel="loading"
      />
    </div>
  );
}

export default Spinner;